function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{font-size:250px;font-family:SourceSansPro-Black, Source Sans Pro;font-weight:800;}.cls-3{letter-spacing:-0.02em;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "CSSE");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M356.31,114.29c-4.13-39.83-26.5-81.41-65.78-96C247.18,2.14,198.85,23.19,163.1,47.91c-37.46,25.91-67.26,61.51-91.79,99.54A627,627,0,0,0,24.64,233C14,257,4.84,282.11,1.36,308.24c-6,44.82,7.86,91.86,39.86,124.34,33.13,33.64,81.7,44.35,126.75,51.16,93.38,14.11,188.64,1.64,278.1-27.15,94.77-30.49,183.51-78.08,266.08-133.23q16-10.69,31.73-21.78c3.24-2.28,6.44-8,8.44-11.05,4.24-6.4,8.21-13.1,11.82-19.87,2.81-5.25,5.82-10.58,7.77-16.21.32-.91,2.2-5.66-.49-3.78-53.81,37.89-110,72.61-168.91,102q-24.53,12.21-49.68,23.1l1.22-.53c-73.52,31.66-151.44,54.36-231.47,60.69a547.55,547.55,0,0,1-118-3.15c-38-5.24-78.7-12.87-111.33-34.18-35.2-23-57.43-62-62.33-103.43l.15,1.32c-2.46-23.15.6-46.65,7.44-68.85,1.65-5.37,3.53-10.69,5.52-15.95q1.56-4.1,3.23-8.14c-.3.71-1.24,2.87.19-.44q1-2.35,2.05-4.69c1.14-2.58,2.32-5.13,3.5-7.69,1.76-3.84-.21.34-.47.94.66-1.53,1.47-3,2.21-4.51,1-2,2.12-3.92,3-5.94-3.7,8.27,1.16-2,2.16-3.84-4.76,9-.62,1.2.57-.86,2.06-3.56-4.26,7-1.16,2,.57-.92,1.13-1.85,1.69-2.76,1-1.65,4.48-6-.4.59.63-.84,1.18-1.82,1.75-2.7l1.77-2.67L66,168.25c-1.79,2.61-2.19,3.2-1.18,1.75,1.38-1.94,2.73-3.89,4.13-5.81.92-1.27,1.87-2.53,2.8-3.8.42-.57,2.12-2.79,0,0q4.73-6.15,9.73-12.07a282.29,282.29,0,0,1,41-39.76,240.12,240.12,0,0,1,53.33-32.09l-1.23.53c27.63-11.65,59-17.51,87.75-6.13,22,8.7,39.21,27,50.11,47.61a127.47,127.47,0,0,1,13.47,43.15l-.16-1.32c.14,1.09.26,2.18.37,3.27.29,2.82,2.44-.22,3.51-1.46,3.84-4.42,7.14-9.88,10.16-14.84,4-6.57,7.9-13.25,11.29-20.17,1.65-3.34,5.73-9.11,5.35-12.83Z"
}), React.createElement("text", {
  className: "cls-2",
  transform: "translate(367.27 207.5)"
}, React.createElement("tspan", {
  className: "cls-3"
}, "S"), React.createElement("tspan", {
  x: 136,
  y: 0
}, "SE"))));

var SvgCsse = function SvgCsse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 783.27 489.56",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCsse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CSSE.8428fe8c.svg";
export { ForwardRef as ReactComponent };